import { createContext, useContext } from 'react'
import type { StripeDataType } from 'src/cms/hooks/getProductStripeData'

type DiscountStripeProviderProps = {
  children: React.ReactNode
  stripeData: StripeDataType | null
}

type DiscountStripeContextProps = {
  stripeData: StripeDataType | null
}

const DiscountStripeContext = createContext<DiscountStripeContextProps>({
  stripeData: null,
})

export const DiscountStripeProvider = ({
  children,
  stripeData = null,
}: DiscountStripeProviderProps) => {
  return (
    <DiscountStripeContext.Provider value={{ stripeData }}>
      {children}
    </DiscountStripeContext.Provider>
  )
}

export const useDiscountStripeContext = () => useContext(DiscountStripeContext)
